import { Transition } from '@headlessui/react';
import {
	CheckCircleIcon,
	ExclamationCircleIcon,
} from '@heroicons/react/24/outline';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

const Notification = ({ isShown = true, type, message }) => {
	return (
		<Transition
			show={isShown}
			as={Fragment}
			enter="transform ease-out duration-300 transition"
			enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
			enterTo="translate-y-0 opacity-100 sm:translate-x-0"
			leave="transition ease-in duration-100"
			leaveFrom="opacity-100"
			leaveTo="opacity-0"
		>
			<div
				role="alert"
				className={cn('alert', {
					'alert-success': type === 'success',
					'alert-error': type === 'error',
				})}
			>
				{type === 'success' && (
					<CheckCircleIcon className="w-6 h-6" aria-hidden="true" />
				)}
				{type === 'error' && (
					<ExclamationCircleIcon className="w-6 h-6" aria-hidden="true" />
				)}
				<span>{message}</span>
			</div>
		</Transition>
	);
};

Notification.propTypes = {
	type: PropTypes.string,
	message: PropTypes.string,
	isShown: PropTypes.bool,
};

export default Notification;
